/* eslint-disable */

import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { animateScroll as scroll } from "react-scroll";
import Slider from "react-slick";
import buttonArrow from "../assets/img/button_arrow_icon.png";
import mainVisual from "../assets/video/main_visual.mp4";
import mainVisual2 from "../assets/video/main_visual2.mp4";
import upstage from "../assets/img/upstage.png";
import { getAllSlide } from "../api/SlideApi";

// css
import "../css/VisualSlide.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function VisualSlide() {
  const [slides, setSlides] = useState([]);

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    vertical: false,
  };

  const handleSubscribe3 = () => {
    window.open(
      "https://www.automationanywhere.com/kr/products/automation-360",
      "_blank"
    );
  };

  const handleSubscribe4 = () => {
    window.open("https://www.automationanywhere.com/kr", "_blank");
  };

  const handleContactButtonClick = () => {
    scroll.scrollTo(1740, {
      duration: 100,
      delay: 0,
      smooth: "easeInOutQuart",
      offset: 0,
      top: 0,
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const slidesArray = await getAllSlide();
        console.log(slidesArray);
        setSlides(slidesArray);
      } catch (err) {
        console.error("Error fetching slides", err);
      }
    };
    fetchData();
  }, []);

  const isImageUrl = (url) => /\.(jpe?g|png|gif|bmp|webp)(\?.*)?$/i.test(url);

  return (
    <div className="visual_container">
      <Slider {...settings}>
        {slides.map((slide) => {
          const titles = slide.button_title?.split(",") || [];
          const links = slide.button_link?.split(",") || [];
          return (
            <div key={slide.id} className="visual_slide">
              <video loop autoPlay muted playsInline>
                <source src={slide.bg_video || mainVisual} type="video/mp4" />
              </video>
              <div className="container">
                <div className="visual_text">
                  {slide.first_header &&
                    (isImageUrl(slide.first_header) ? (
                      <img
                        src={slide.first_header}
                        alt="슬라이드 헤더 이미지"
                        className="heading3 visual_img"
                      />
                    ) : (
                      <p className="heading3">{slide.first_header}</p>
                    ))}
                  {slide.second_title && (
                    <p className="display2">
                      {slide.second_title.split("\n").map((line, idx) => (
                        <span key={idx}>
                          {line}
                          <br />
                        </span>
                      ))}
                    </p>
                  )}
                  {slide.third_line && (
                    <p className="sub_title4">{slide.third_line}</p>
                  )}

                  <div>
                    {titles.map((title, idx) => {
                      const url = links[idx] || "#";
                      const isExternal = url.startsWith("http");
                      return isExternal ? (
                        <a
                          key={idx}
                          href={url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="blue_btn button1"
                        >
                          {title}
                          <img src={buttonArrow} alt="바로가기" />
                        </a>
                      ) : (
                        <NavLink
                          key={idx}
                          to={url}
                          className="blue_btn button1"
                        >
                          {title}
                          <img src={buttonArrow} alt="바로가기" />
                        </NavLink>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
}

export default VisualSlide;
